// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 572 ? "polySeg" : chunkId) + "." + {"213":"86cfd9d9","572":"36bf5276","667":"c9451775"}[chunkId] + ".chunk.js";
};